export const CLIENT_PRIMARY_TABS = [
  { id: "overview", label: "Vue d’ensemble" },
  { id: "settings", label: "Réglages" },
  { id: "technical", label: "Technique" },
];

export const CLIENT_TECHNICAL_SECTIONS = [
  { id: "messaging", label: "Messagerie" },
  { id: "twilio", label: "Twilio" },
  { id: "chakra", label: "Chakra" },
  { id: "plato", label: "Plato" },
  { id: "ai-prompts", label: "IA et prompts" },
  { id: "maintenance", label: "Maintenance" },
];

export const CLIENT_SETTINGS_SECTIONS = [
  { id: "experience-pdpa", label: "Conversation et PDPA" },
  { id: "blocked-answers", label: "Blocked answers" },
  { id: "hours", label: "Horaires" },
  { id: "automation", label: "Automation du bot" },
  { id: "practitioners", label: "Praticiens" },
  { id: "rbac", label: "Administration RBAC" },
];

export function getNextOpenClientIds(current, clientId) {
  return current.has(clientId) ? new Set() : new Set([clientId]);
}

export function hasSectionChanges(original, draft) {
  return JSON.stringify(original) !== JSON.stringify(draft);
}

export function maskClientSecret(value) {
  if (!value) return "Non configuré";
  if (value.length <= 4) return "••••";
  return `••••••••${value.slice(-4)}`;
}

const SECTION_FIELDS = {
  overview: ["raison_sociale", "nom", "prenom", "telephone", "email", "twilio_numero", "sim_numero_serie"],
  "experience-pdpa": ["whatsapp_provider", "handler_name", "default_language", "currency_code", "ai_response_temperature", "pdpa_consent_message", "pdpa_consent_messages_enabled", "is_label", "assistant_label", "enable_desktop_split_view", "rbac_enabled", "status_tags_enabled", "conversation_statuses", "enable_reopening_digest", "enable_experience_intelligence", "enable_quick_messages"],
  automation: ["bot_schedule_enabled", "bot_schedule_hours"],
  messaging: ["whatsapp_provider", "handler_name", "twilio_numero", "sim_numero_serie"],
  twilio: ["twilio_sid", "twilio_auth_token", "main_account_twilio", "sub_account_twilio"],
  chakra: ["chakra_client_id", "chakra_client_secret", "chakra_refresh_token", "chakra_access_token", "chakra_access_token_expires_at", "chakra_phone_number_id", "chakra_plugin_id", "chakra_api_version"],
  plato: ["plato_appt_status_field", "plato_appt_status_map"],
  "ai-prompts": ["ai_response_temperature", "slot_offer_limit", "availability_presentation", "ical_empty_calendar_means_available", "prompt_template", "prompt_guardrail"],
};

export function pickClientSectionPayload(section, draft) {
  return Object.fromEntries((SECTION_FIELDS[section] ?? []).filter((key) => Object.prototype.hasOwnProperty.call(draft, key)).map((key) => [key, draft[key]]));
}
